import { useEffect,useContext , useState, useRef } from 'react';
import { ButtonLoader } from '../../utils/ButtonLoader';
import { AppContext } from '../../../AppContextProvider';
import Charges from './photovoltaique/Charges';
import Histogram from '../../utils/Histogramme';
import { BrowserView, MobileView,isBrowser,isMobile } from 'react-device-detect';
import { useFetch } from '../../api/FetchApiData';
import { MediaUrl } from '../../utils/Media';
import { VitrineContext } from '../VitrineContext';
import { useWindowHeight } from '@react-hook/window-size';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
if (isMobile)
    import('./filtres_mob.css').then(() => {});
else
    import('./filtres.css').then(() => {});

export default function Filtres({close=()=>{}})
{
    const [FilterBtn,setFilterBtn] = useState({display:'block',text:'-'});
    const [loading,setLoading] = useState(false);
    const [rayon,setRayon] = useState({categories:[]});
    const [Categories,setCategories] = useState([]);
    const [manufacturers,setManufacturers] = useState([]);
    const [displays,setDisplays] = useState({category:'none',manufacturer:'none'});
    const [AppState,setAppState] = useContext(AppContext);
    const fetchData = useFetch({AppState,setAppState});
    const [rayons,setRayons] = useState([]);
    const [histograms,setHistograms] = useState([]);
    const [filters,setFileters] = useState({categories:[],manufacturers:[],prices:{min:null,max:null}, characteristics:{char_ids:[], values:[]}});
    const [vitrines,setVitrines] = useContext(VitrineContext);
    const { t } = useTranslation();
    const screenHeight = useWindowHeight();
    const loaded = useRef(false);
    const navigator = useNavigate();

    useEffect(()=>{
        if(filters.rayon!==null && isBrowser)
        {
            let _filters = {
                categories : JSON.stringify(filters.categories),
                manufacturers : JSON.stringify(filters.manufacturers),
                characteristics: JSON.stringify(filters.characteristics),
                prices:JSON.stringify(filters.prices)
              };
            setVitrines({...vitrines,articles:[],filters:_filters,page:1});
            vitrines.reload(true);
        }
    },[filters]);

    const FetchFilters = async (check_rayon_length=true)=>
    {
        if(rayons.length>0 && check_rayon_length)
            return
        setLoading(true);
        let arr = []
        fetchData.GetData('filter/').then((result)=>{
            if(result.result)
            {
                //console.log(result);
                setRayons(result.rayons);
                //console.log(result.rayons);
                /*
                result.rayons.forEach(ray=>{
                    ray.categories.forEach((cat)=>{
                        Object.keys(cat.histogram).forEach((price)=>{
                            var pic = {};
                            pic[price] = cat.histogram[price];
                            arr.push(pic);
                        });    
                    });
                });
                arr = arr.sort((a,b)=>Number(Object.keys(a)[0])-Number(Object.keys(b)[0]));
                let hists = {};
                if(arr.length>0)
                {
                    var key = (2*Number(Object.keys(arr[0])[0])+100)/2;
                    hists[key.toString()] = 0
                }
                arr.forEach((hist)=>{
                    if(Math.abs(Number(Object.keys(hist)[0])-key) < 50)
                    {
                        hists[key.toString()] = hists[key.toString()]+ Object.values(hist)[0];
                        console.log(hist);
                    }
                    else
                    {
                        key = (2*Number(Object.keys(hist)[0])+100)/2;
                        hists[key.toString()] = Object.values(hist)[0];
                    }
                });
                var chart = [];
                Object.keys(hists).forEach(key=>{
                    var pic = {};
                    pic[key] = hists[key];
                    chart.push(pic);
                });
                setHistograms([...chart]);
                */
                setLoading(false);
                loaded.current = true;
            }

        });
    }
    /*
    useEffect(()=>{
        FetchFilters();
    },[])
    */
    useEffect(()=>{
        //console.log("Filter lang", AppState.settings);
        //setRayons([]);
        setCategories([]);
        setManufacturers([]);
        setRayon({categories:[]});
        FetchFilters(false);
    },[AppState.settings.lang,AppState.settings.devise])
    
    
    useEffect(()=>{
        if(Categories.length>0)
            setDisplays({...displays,manufacturer:'block'});
        else
            setDisplays({...displays,manufacturer:'none'});
        let arr = [];
        let _harr = []
        Categories.forEach(cat=>{
            arr.push(cat.id);
            /*
            Object.keys(cat.histogram).forEach((price)=>{
                var pic = {};
                pic[price] = cat.histogram[price];
                _harr.push(pic);
            });
            */  
        });
        setFileters({...filters,categories:arr});
        /*
        _harr = _harr.sort((a,b)=>Number(Object.keys(a)[0])-Number(Object.keys(b)[0]));
        let hists = {};
        if(_harr.length>0)
        {
            var key = (2*Number(Object.keys(_harr[0])[0])+100)/2;
            hists[key.toString()] = 0
        }
        _harr.forEach((hist)=>{
            if(Math.abs(Number(Object.keys(hist)[0])-key) < 50)
            {
                hists[key.toString()] = hists[key.toString()]+ Object.values(hist)[0];
                console.log(hist);
            }
            else
            {
                key = (2*Number(Object.keys(hist)[0])+100)/2;
                hists[key.toString()] = Object.values(hist)[0];
            }
        });
        var chart = [];
        Object.keys(hists).forEach(key=>{
            var pic = {};
            pic[key] = hists[key];
            chart.push(pic);
        });
        setHistograms([...chart]);
        */
    },[Categories])

    useEffect(()=>{
        if(rayon.categories.length>0)
            setDisplays({...displays,category:"block"});
        else
            setDisplays({...displays,category:"none"});
        /*
        let arr = [];
        rayon.categories.forEach((cat)=>{
            Object.keys(cat.histogram).forEach((price)=>{
                var pic = {};
                pic[price] = cat.histogram[price];
                arr.push(pic);
            });    
        });

        arr = arr.sort((a,b)=>Number(Object.keys(a)[0])-Number(Object.keys(b)[0]));
        let hists = {};
        if(arr.length>0)
        {
            var key = (2*Number(Object.keys(arr[0])[0])+100)/2;
            hists[key.toString()] = 0
        }
        arr.forEach((hist)=>{
            if(Math.abs(Number(Object.keys(hist)[0])-key) < 50)
            {
                hists[key.toString()] = hists[key.toString()]+ Object.values(hist)[0];
                console.log(hist);
            }
            else
            {
                key = (2*Number(Object.keys(hist)[0])+100)/2;
                hists[key.toString()] = Object.values(hist)[0];
            }
        });
        var chart = [];
        Object.keys(hists).forEach(key=>{
            var pic = {};
            pic[key] = hists[key];
            chart.push(pic);
        });
        setHistograms([...chart]);
        */
    },[rayon])

    useEffect(()=>{
        
        if (vitrines.histogram === undefined || vitrines.histogram===null)
            return
        var arr =[];
        Object.keys(vitrines.histogram).forEach((price)=>{
            var pic = {};
            pic[price] = vitrines.histogram[price];
            arr.push(pic);
        }); 
        arr = arr.sort((a,b)=>Number(Object.keys(a)[0])-Number(Object.keys(b)[0]));
        let hists = {};
        if(arr.length>0)
        {
            var key = (2*Number(Object.keys(arr[0])[0])+100)/2;
            hists[key.toString()] = 0
        }
        arr.forEach((hist)=>{
            if(Math.abs(Number(Object.keys(hist)[0])-key) < 50)
            {
                hists[key.toString()] = hists[key.toString()]+ Object.values(hist)[0];
            }
            else
            {
                key = (2*Number(Object.keys(hist)[0])+100)/2;
                hists[key.toString()] = Object.values(hist)[0];
            }
        });
        var chart = [];
        Object.keys(hists).forEach(key=>{
            var pic = {};
            pic[key] = hists[key];
            chart.push(pic);
        });
        setHistograms(chart);
    },[vitrines.histogram])

    const HandleRayonClick = (index,checked)=>
    {
        setRayon(rayons[index]);
        if(checked)
        {
            let arr = [];
            rayons[index].categories.forEach((cat)=>{arr.push(cat.id);})
            setFileters({...filters,categories:arr});
        }
            
    }
    
    const MarkedRayon = (text)=>{
        const elements = text.split('*');
        if(elements.length>1)
        {
            return(
                    <div style={{display:'inline-block',verticalAlign:'middle',wordWrap:'break-word',maxWidth:'50%'}}>
                        <label style={{display:'inline-block',verticalAlign:'middle',wordWrap:'break-word',maxWidth:'100%'}}>{elements[0]}</label>
                        <label className='filter-cat-label' style={{verticalAlign:'middle',display:'block',fontSize:'xx-small',color:'gray'}}>{elements[1]}</label>
                    </div>
            );
        }
        else{
            return(<label style={{display:'inline-block',verticalAlign:'middle',wordWrap:'break-word',maxWidth:'50%'}}>{text}</label>);
        }
    };

    const RayonCheckBox = (label,index,count=0,img={disp:false,src:''},displaycount='none')=>
    {
        let margintop = '2px';
        margintop = isBrowser ? '13px' : '13px';
        return(
        <div key={label} style={{position:'relative',width:'100%',textAlign:'left',marginTop:'5px'}}>
            <img src={img.src} style={{display:'inline-block',width:'40px',height:'40px',borderRadius:'20px',verticalAlign:'middle',marginRight:'10px'}}/>
            {/*<label style={{display:'inline-block',verticalAlign:'middle',wordWrap:'break-word',maxWidth:'50%'}}>{label}</label>*/}
            {MarkedRayon(label)}
            <input style={{position:'absolute',right:'10px',top:margintop,verticalAlign:'middle',width:'15px'}} checked={label===rayon.name} onChange={e=>{}} onClick={(e)=>{HandleRayonClick(index,e.target.checked)}} type='checkbox' />
        </div>);
    }

    const HandleManufacturerClick = (man, checked)=>
    {
        if(checked)
        {
            setFileters({...filters,manufacturer:[...filters.manufacturers,man.id]});
        }
        else
        {
            filters.manufacturers.pop(man.id);
            setFileters({...filters});
        }
    } 

    const ManCheckBox = (man)=>
    {
        let margintop = '2px';
        margintop = isBrowser ? '5px' : '0px';
        return(
        <div style={{display:'block',width:'100%',textAlign:'left',marginTop:'5px',position:'relative'}}>
            <img src={MediaUrl(man.logo.image)} style={{width:'20px',height:'20px',display:'inline-block',borderRadius:'20px',verticalAlign:'middle',marginRight:'10px'}}/>
            <label style={{display:'inline-block',verticalAlign:'middle'}}>{man.name}
            <span style={{color:'gray'}}>{' ('+man.articles.length+')'}</span></label>
            <input onClick={(e)=>{HandleManufacturerClick(man,e.target.checked)}} type='checkbox' style={{position:'absolute',right:'10px',width:'15px',top:'0px',marginTop:margintop,verticalAlign:'middle'}} />
        </div>);
    }

    const MarkedText = (text,count)=>{
        const elements = text.split('*');
        if(elements.length>1)
            return(
                <div style={{display:'flex',flexDirection:'row',justifyItems:'center',alignItems:'center',placeItems:'center'}}>
                    <div>
                        <label className='filter-cat-label' style={{verticalAlign:'middle',display:'block'}}>{elements[0]}</label>
                        <label className='filter-cat-label' style={{verticalAlign:'middle',display:'block',fontSize:'xx-small',color:'gray'}}>{elements[1]}</label>
                    </div>
                    <span style={{color:'gray',marginLeft:'10px'}}>{' ('+count+')'}</span>
                </div>
        )
        else{
            return(<div className='filter-cat-label' style={{verticalAlign:'middle',display:'flex',flexDirection:'row'}}><div><label>{text}</label></div>
            <span style={{color:'gray',marginLeft:'10px'}}>{' ('+count+')'}</span></div>)
        }
    }

    const CatCheckBox = (category,count=0,displaycount='none',index)=>
    {
        return(
        <div key={index} style={{position:'relative',display:'block',width:'100%',textAlign:'left',marginTop:'10px'}}>
            {MarkedText(category.name,category.count)}
            <input onClick={(e)=>{HandleCategorieClick(category,e.target.checked)}} type='checkbox' style={{position:'absolute',right:'10px',width:'15px',top:'0px',verticalAlign:'middle'}} />
        </div>);
    }

    const HandleCategorieClick=(cat,checked)=>
    {
        if(checked)
        {
            Categories.push(cat);
        }
        else
        {let index = Categories.indexOf(cat);Categories.splice(index,1);}
        setCategories([...Categories]);
        let arr = [];
        Categories.forEach((cat)=>{
            cat.manufacturers.forEach((man)=>{
            const exist = arr.find(m=>m.id===man.id)
            if(exist === undefined)
            {arr.push(man);}})
        });
        setManufacturers([...arr]);
    }

    const HandleDisplay=()=>
    {
        if(FilterBtn.display=='none')
        {setFilterBtn({display:'block',text:'-'});}
        else{setFilterBtn({display:'none',text:'+'});}
    }

    const HandleMinMaxChange=(min,max)=>
    {
        //setFilterPrices({min:min,max:max});
    }

    const ApplyFiltres = (prices)=>
    {
        if(filters.rayon!==null)
        {
            let _filters = {
                categories : JSON.stringify(filters.categories),
                manufacturers : JSON.stringify(filters.manufacturers),
                characteristics: JSON.stringify(filters.characteristics),
                prices:JSON.stringify(prices)
                };
            setVitrines({articles:[],filters:_filters,page:1});
        }
    }

    const ShowProjectFilters = ()=>
    {
        if(isMobile)
        {
            switch (rayon.name) {
                case 'Photovoltaique':
                    navigator('/photovoltaique/sizing/');
                    break;
                default:
                    break;
            }
        }
    }

    const BtnAdvancedFilter=()=>
    {
        switch (rayon.name) {
            case 'Photovoltaique':
                return <Charges />
            case 'Kits Solaires':
                return <Charges />
            default:
                return
        }
    }

    const HandleClickCharacteristic = (char_id, value, checked)=>
    {
        if(checked)
        {
            filters.characteristics.char_ids.push(char_id);
            filters.characteristics.values.push(value);
        }
        else
        {
            filters.characteristics.char_ids.pop(char_id);
            filters.characteristics.values.pop(value);
        }
        console.log(filters);
        setFileters({...filters});
    }

    var style = {};
    if(isMobile)
         style = {maxHeight:(screenHeight-80-60).toString()+'px'};

    return(
    <div id="FiltresBlock" style={style}>
        <fieldset className='FiltresFieldset' style={{marginBottom:'10px',paddingBottom:'0px'}}>
            <legend>{t('filters.prix')}</legend>
            <Histogram ApplyFilters={ApplyFiltres} histograms={histograms} filters={filters} setFilters={setFileters} />
        </fieldset>
        <MobileView>
            {
                //<input className='btn-apply-filters' type='button' value={'Appliquer'} style={{border:'none'}}  onClick={(e)=>{ApplyFiltres();close();}} />
            }
            <div id="FiltresTitle" style={{width:'100%',display:'inline-block'}}>
                <div className="BtnDispFilters"><ButtonLoader text={FilterBtn.text} onSubmit={e=>{HandleDisplay()}} style={{backGroundColor:'goldenrod',fontSize:'large',color:'black'}} loading={loading}/></div>
                <span>{t('filters.filtres')}</span>
            </div>
        </MobileView>
        <BrowserView>
            <div id="FiltresTitle">
                <div className="BtnDispFilters"><ButtonLoader text={FilterBtn.text} onSubmit={e=>{HandleDisplay()}} style={{backGroundColor:'goldenrod',fontSize:'large',color:'black'}} loading={loading}/></div>
                <span>{t('filters.filtres')}</span>
            </div>
        </BrowserView>
        <div style={{display:FilterBtn.display}}>
            <fieldset className='FiltresFieldset'>
                <legend>{t('filters.rayons')}</legend>
                {
                    rayons.map((rayon,index)=>{
                    return(RayonCheckBox(rayon.name,index,0,{disp:true,src:MediaUrl(rayon.image)}))})
                }
            </fieldset>

            <fieldset style={{display:displays.category}} className='FiltresFieldset'>
                <legend>{t('filters.categories')}</legend>
                {
                    rayon.categories.map((cat,index)=>
                    {
                        return CatCheckBox(cat,0,HandleCategorieClick,index);
                    })   
                }
            </fieldset>

            <fieldset style={{display:displays.manufacturer}} className='FiltresFieldset'>
                <legend>{t('filters.fabricants')}</legend>
                    {
                        manufacturers.map((man)=>{
                            return(
                                ManCheckBox(man,man.articles.length)
                            )
                        })
                    }           
            </fieldset>
            
            {Categories.map((cat)=>{
                if(Object.keys(cat.characteristics).length>0)
                {
                return(
                    <fieldset className='FiltresFieldset' style={{paddingTop:'10px'}}>
                        <legend>{cat.name}</legend>
                            {
                                Object.keys(cat.characteristics).map((_key)=>
                                {
                                    return(<div style={{textAlign:'left',width:'100%'}}>
                                        <label><b>{_key}</b></label>
                                            <hr/>
                                             {Object.keys(cat.characteristics[_key].values).map((key)=>{
                                                return(
                                                    <div style={{textAlign:'left',marginBottom:'5px',position:'relative',width:'100%',display:'flex',flexDirection:'row'}}>
                                                        <div style={{display:'flex',flexDirection:'row'}}><label><i><span>{key}</span></i></label><label><i><span style={{marginLeft:'10px'}}>({cat.characteristics[_key].values[key]})</span></i></label></div> 
                                                        <input onChange={e=>{HandleClickCharacteristic(cat.characteristics[_key].char_id,key,e.target.checked)}} style={{position:'absolute',right:'10px',width:'15px'}} type='checkbox' />
                                                    </div>
                                                );
                                             })}
                                        </div>
                                        )      
                                })
                            }
                    </fieldset>
                );
            }
            })}
        </div>
        {BtnAdvancedFilter()}
    </div>);
}